import { getCustomerQuery, getAddressQuery } from '@setvi/shared/services';
import { useQuery } from '@tanstack/react-query';

interface UseCustomerProps {
  customerId?: string;
  addressId?: string;
}

export const useCustomer = ({ customerId, addressId }: UseCustomerProps) => {
  const { data: customer, isFetching: isCustomerFetching } = useQuery({
    ...getCustomerQuery({ customerId }),
    enabled: !!customerId
  });

  const { data: address, isFetching: isAddressFetching } = useQuery({
    ...getAddressQuery({ addressId }),
    enabled: !!addressId
  });

  return {
    customer,
    address,
    isLoading: isCustomerFetching || isAddressFetching
  };
};
